// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".userState_FxPyo{visibility:collapse}", ""]);
// Exports
exports.locals = {
	"userState": "userState_FxPyo"
};
module.exports = exports;
